import manifest from './route-manifest.json';
import { englishPath, localizePath, SITE_LOCALE, type Locale } from './locale';

/** Explicit publication gate: only reviewed, complete catalog sets get PT routes. */
export function translationAvailable(path: string): boolean {
  return manifest.some(route => route.path === englishPath(path) && route.ptBRComplete === true);
}

/** localizePath, except that a page with no Portuguese version links to the English one (on gizmodata.com). */
export function localizeHref(value: string, locale: Locale, site: Locale = SITE_LOCALE): string {
  if (locale === 'pt-BR' && value.startsWith('/') && !value.startsWith('//')) {
    const path = englishPath(value.split(/[?#]/)[0]);
    if (manifest.some(route => route.path === path) && !translationAvailable(path)) return localizePath(value, 'en', site);
  }
  return localizePath(value, locale, site);
}
